export const FETCHING_ITEMS = "FETCHING_DVD_MOVIES";
export const FETCHED_ITEMS = "FETCHED_DVD_MOVIES";
export const RECEIVED_ITEMS = "RECEIVED_DVD_MOVIES";
export const FETCHING_MORE_ITEMS = "FETCHING_MORE_DVD_MOVIES";
export const FETCHED_MORE_ITEMS = "FETCHED_MORE_DVD_MOVIES";
export const RECEIVED_MORE_ITEMS = "RECEIVED_MORE_DVD_MOVIES";
export const UPDATED_FILTERS = "UPDATED_DVD_FILTERS";
export const REPLACED_FILTERS = "REPLACED_DVD_FILTERS";
